/* src/app/tb-activate-voucher/tb-activate-voucher.component.scss */
.wrapper {
  overflow-y: auto;
  height: calc(100vh - 16px);
  overflow-x: clip;
  padding: 8px;
  background-color: var(--background-color);
}
.wrapper .general-terms {
  position: relative;
  top: -16px;
  margin-bottom: 8px;
}
.wrapper .general-terms a {
  color: var(--text-color);
}
.wrapper .voucher-terms mat-label {
  color: rgba(0, 0, 0, 0.6) !important;
}
.wrapper .voucher-terms textarea {
  color: rgba(0, 0, 0, 0.87) !important;
}
.wrapper .checkbox {
  margin-bottom: 8px;
  min-width: 100%;
}
.wrapper .terms-cb {
  position: relative;
  top: -16px;
}
.wrapper .activate-card {
  margin: auto;
  width: 300px;
  box-shadow: none;
}
.wrapper .activate-card .logo-wrapper .logo {
  height: 50px;
  content: var(--logo-fullwidth);
}
.wrapper .activate-card .img-wrapper {
  margin: -16px 0px 16px;
  height: 140px;
  text-align: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
.wrapper .activate-card .title {
  margin-bottom: 16px;
  font-size: 26px;
  color: var(--title-color);
}
.wrapper .activate-card .sub-title {
  font-size: 15px;
}
.wrapper .activate-card .hint-text {
  height: 8px;
  align-items: flex-end;
}
.wrapper .activate-card .hint-text .mat-hint {
  height: 17px;
  float: right;
  position: relative;
  bottom: 16px;
  right: 0px;
}
.wrapper .activate-card .statistics {
  left: 0;
  right: 0;
  margin: auto;
  top: 40px;
  max-width: 200px;
}
.wrapper .activate-card .statistics .statistic {
  font-size: 50px;
  text-align: center;
  color: var(--title-color);
}
.wrapper .activate-card .statistics .subtitle {
  font-size: 14px;
  text-transform: uppercase;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
}
.wrapper .activate-card form {
  margin-top: 24px;
}
.wrapper .activate-card form mat-form-field {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-width: 100%;
}
.wrapper .activate-card .mat-card-actions {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
.wrapper .activate-card .mat-card-actions button {
  width: 316px;
  text-transform: uppercase;
  background-color: var(--background-color);
  color: white;
}
.wrapper .requestForm button {
  margin-right: 12px;
}
.wrapper .requestForm mat-card-content {
  margin-bottom: 36px;
}
.wrapper .acitvateDateNotPassed {
  margin-top: 6px;
}
.wrapper .acitvateDateNotPassed span {
  color: red;
}
.loading-wrapper {
  height: 100vh;
  width: 100vw;
}
.loading-wrapper .loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  border-top-color: #000000;
  animation: spinner 0.8s linear infinite;
}
.disabledInputs {
  display: block !important;
}
.disabledInputs ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline,
.disabledInputs ::ng-deep .mat-form-field-label,
.disabledInputs ::ng-deep .mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline,
.disabledInputs ::ng-deep .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick,
.disabledInputs #postal,
.disabledInputs #houseNumber,
.disabledInputs #houseNumberAddition {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: default;
}
.enabledInputs {
  display: block !important;
}
::ng-deep .mat-form-field.mat-focused .mat-form-field-label {
  color: var(--text-color);
}
::ng-deep .mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline {
  color: var(--text-color) !important;
}
::ng-deep .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: var(--text-color);
}
::ng-deep .mat-checkbox-checked.mat-accent .mat-checkbox-background {
  background-color: var(--text-color);
}
.activate-voucher-form {
  display: flex;
  flex-wrap: wrap;
}
/*# sourceMappingURL=tb-activate-voucher.component.css.map */
